
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';


import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AttachmentsModalComponent } from '../shared/components/attachments-modal/attachments-modal.component';
import { DiaryFormModalComponent } from '../shared/components/diary-form-modal/diary-form-modal.component';
import { SearchComponent } from '../shared/components/search/search.component';
import { FileUploaderComponent } from '../shared/components/file-uploader/file-uploader.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatButtonModule,
    SearchComponent,
    FileUploaderComponent
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    AttachmentsModalComponent,
    DiaryFormModalComponent
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    AttachmentsModalComponent,
    DiaryFormModalComponent,
    SearchComponent,
    FileUploaderComponent
  ]
})
export class ComponentsModule { }
